import { Box, Paper, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import dash from "../../real.module.css"
import classes from "../analytics.module.css"
import { Delta } from "./AnalyticsCard"

export type ChangeEntry = {
  sign: "up" | "down" | "flat"
  text: string
  /** Translation key for label (e.g. "analytics.kpis.vsPrevMonth"). Optional. */
  labelKey?: string
  /** Fallback label if labelKey missing. */
  label?: string
}

type Props = {
  label: string
  value: string
  unit?: string
  changes?: ChangeEntry[]
  /** The value is a name, not a figure (e.g. the top-margin product). */
  textValue?: boolean
}

// Same card as the overview KPI row (canvas Ord_Dashboard): caps label, big
// figure with a muted unit, neutral arrow + period lines.
export function KpiCard({ label, value, unit, changes, textValue }: Props) {
  const { t } = useTranslation(["dashboard"])
  return (
    <Paper className={dash.statCard}>
      <Text className={dash.statLbl}>{label}</Text>
      <Text className={`${classes.kpiVal} ${textValue ? classes.kpiValText : ""}`}>
        {value}
        {unit ? <Text component="span" className={dash.statUnit}>{unit}</Text> : null}
      </Text>
      {changes && changes.length > 0 ? (
        <Box className={classes.kpiChanges}>
          {changes.map((c, i) => (
            <Text key={i} component="div" className={classes.kpiChange}>
              <Delta sign={c.sign} text={c.text} />
              {c.labelKey ? t(c.labelKey, { defaultValue: c.label ?? "" }) : c.label}
            </Text>
          ))}
        </Box>
      ) : null}
    </Paper>
  )
}
